if(!customElements.get('history-making')) {
    class ComponentHistorySlider extends HTMLElement {
      constructor() {
        super();
        this.sliderElement = this.querySelector('.keen-slider');
  
        this.carouselMode = this.dataset.carouselMode;
        this.carouselLoop = this.dataset.carouselLoop;
        this.carouselAutoplay = this.dataset.carouselAutoplay;
        this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
        this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
        this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
        this.carouselCenteredTablet = this.dataset.carouselCenteredTablet;
        this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
        this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
        this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
        this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
        this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;
  
        setTimeout(()=>{ //The timeout is for the customizer
          this.initSlider();
        }, 1);
      }
  
      initSlider() {
        this.sliderObj = new KeenSlider(this.sliderElement, {
          mode: this.carouselMode,
          loop: this.carouselLoop=="true",
          dots: this.querySelector('.keen-dots'),
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          autoplay: this.carouselAutoplay,
          navBar: '.keen .keen-progress-bar',
          navBarType: 'progress',
          breakpoints: {
            '(min-width: 901px)': {
              centered: this.carouselCenteredDesktop=="true",
              spacing: this.carouselSpacingDesktop,
              slidesPerView: this.slidesPerViewDesktop
            },
            '(min-width: 601px) and (max-width: 900px)': {
              centered: this.carouselCenteredTablet=="true",
              spacing: this.carouselSpacingTablet,
              slidesPerView: this.slidesPerViewTablet
            },
            '(max-width: 600px)': {
              centered: this.carouselCenteredMobile=="true",
              spacing: this.carouselSpacingMobile,
              slidesPerView: this.slidesPerViewMobile
            }
          }
        });
      }
    }
    customElements.define('history-making', ComponentHistorySlider);
  }
